<div class="modal-bg" [ngStyle]="{'background': GlobalConstants.data.colors.coupon_modal_bg_color}">
    <svg class="absolute pointer modal-close-svg" (click)="_bsModalRef.hide()" width="15" height="15"
        viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z"
            fill="#919aa2" />
    </svg>
    <div *ngIf="couponLoading" class="flex align-center justify-center h100 loader-coupon">
        <div class="page-loader"></div>
    </div>
    <div *ngIf="!couponLoading">
        <div class="modal-body coupon-code-pop pad-20 text-center" *ngIf="voucherData && voucherData.success">
          <ng-container *ngIf="selectedOffer?.id !='615639e7-f1b2-4b18-8333-0f9ca1bc4888'; else blinkerMsg">
            <div class="merchant-logo-contain"><img

                    [src]="GlobalConstants.data.logo.coupon_modal_logo"></div>
            <div class="odder-name flex justify-center align-center">
                <div class="modal-mer-logo"><img

                        [src]="selectedOffer?.merchantLogoUrl" class="img-fluid object-fit"></div>
                <span class="offer-text flex align-center ellipse f500">{{selectedOffer?.merchantName}}</span>
            </div>
            <div class="coupon-offer-name pad-top-5 pad-bot-12 fnt-13">
                {{selectedOffer?.offerTitle}}</div>
            <div class="divider-top">
                <img src="./assets/img/other/divider.png">
            </div>
            <div class="coupon-code-main text-center flex-wrap">
                <span class="circle-design c1"></span>
                <span class="circle-design c2"></span>
                <span class="circle-design c3"></span>
                <span class="circle-design c4"></span>

                <div class="coupan-code-box relative" id="redemption_coupon_code"
                    *ngIf="selectedOffer?.offerType != 'no_voucher'">
                    <span class="fnt-17"><b>{{voucherData.offer_type && voucherData.offer_type === 'link_voucher' ? 'No Voucher Required' : voucherData.voucher_code}}</b></span>
                    <button class="copy-icon pointer">
                        <svg (click)="showCopied(voucherData.voucher_code)"
                            width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.57895 0H1.36842C0.615789 0 0 0.654545 0 1.45455V11.6364H1.36842V1.45455H9.57895V0ZM8.89474 2.90909H4.10526C3.35263 2.90909 2.74368 3.56364 2.74368 4.36364L2.73684 14.5455C2.73684 15.3455 3.34579 16 4.09842 16H11.6316C12.3842 16 13 15.3455 13 14.5455V7.27273L8.89474 2.90909ZM4.10526 14.5455V4.36364H8.21053V8H11.6316V14.5455H4.10526Z"
                                fill="white" />
                        </svg>
                    </button>
                </div>
                <div class="coupan-code-box relative" id="redemption_coupon_code"
                    *ngIf="selectedOffer?.offerType == 'no_voucher'">
                    <span class="fnt-17">
                        <b>No Voucher Required</b>
                    </span>
                </div>
                <div class="validity-box">
                    <small id="validity_coupon_code_return">Valid till:
                        <span>{{selectedOffer?.endDate |
                            date:
                            'mediumDate'}}</span></small>
                </div>
            </div>
            <div class="divider-bottom">
                <img src="./assets/img/other/divider.png">
            </div>
            <div class="coupon-code-footer pad-20">
                <div class="fnt-12 f300">Please refer to the Offer Terms and Conditions
                    <!-- <a href="{{'/offer-details/' + selectedOffer?.merchantId + '/all/' + selectedOffer?.merchantName.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase()+'?offer_id='+ selectedOffer?.id +'&terms=true'}}"
                        target="_blank" rel="noreferrer noopener" class="underline terms-link">Terms and Conditions</a> -->
                    on how to redeem this
                    offer
                </div>
                <div class="text-center go-to mar-top-15 mar-bot-5"
                    *ngIf="GlobalConstants.data.personalized_config.modal_redeem_button">
                    <img class="loader" width="31px" *ngIf="redeeming" src="./assets/img/icons/spin.gif">
                    <button *ngIf="!redeeming" class="btn btn-theme shop_now_url fnt-14 cfff"
                        [ngStyle]="{'color': GlobalConstants.data.colors.mainBtn_color}"
                        (click)="goTo()">Redeem</button>
                </div>
            </div>
          </ng-container>
        </div>
        <div class="modal-body coupon-error text-center" *ngIf="voucherData && voucherData.success == false">
            <svg class="mar-top-48" fill="red" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
                <g>
                    <path
                        d="M503.839,395.379l-195.7-338.962C297.257,37.569,277.766,26.315,256,26.315c-21.765,0-41.257,11.254-52.139,30.102    L8.162,395.378c-10.883,18.85-10.883,41.356,0,60.205c10.883,18.849,30.373,30.102,52.139,30.102h391.398    c21.765,0,41.256-11.254,52.14-30.101C514.722,436.734,514.722,414.228,503.839,395.379z M477.861,440.586    c-5.461,9.458-15.241,15.104-26.162,15.104H60.301c-10.922,0-20.702-5.646-26.162-15.104c-5.46-9.458-5.46-20.75,0-30.208    L229.84,71.416c5.46-9.458,15.24-15.104,26.161-15.104c10.92,0,20.701,5.646,26.161,15.104l195.7,338.962    C483.321,419.836,483.321,431.128,477.861,440.586z" />
                </g>
                <g>
                    <rect x="241.001" y="176.01" width="29.996" height="149.982" />
                </g>
                <g>
                    <path
                        d="M256,355.99c-11.027,0-19.998,8.971-19.998,19.998s8.971,19.998,19.998,19.998c11.026,0,19.998-8.971,19.998-19.998    S267.027,355.99,256,355.99z" />
                </g>
            </svg>
            <!-- <div class="fnt-16 ln-28 c333 error-line">
                {{paymentFailed ? 'We were unable to verify your card. Please check the card details entered, or use an eligible card. Please contact your bank if you need assistance.' : 'Something went wrong. Please try again later!'}}
            </div> -->
        </div>
        <div class="modal-body coupon-error text-center" *ngIf="voucherData && voucherData.paymentNeeded == true">
          <div class="redirect-box  text-center" >
            <div class="coupon-code-pop text-center">
              <div class="merchant-logo-contain"><img [src]="GlobalConstants.data.logo.coupon_modal_logo"></div>
              <div class="pad-30 pad-bot-5">You will be redirected for card verification. Please use the card ({{currentCard?.attributes?.bin}} XXXX XXXX) to complete the payment of Rs. {{selectedOffer?.pva}}</div>
              <div class="flex btn-contain flex align-center justify-center mar-top-30 pad-bot-30">
                <button class="btn confirm-btn fnt-14 bg-fff f500  mar-right-10 relative" (click) = "getpayments()">Confirm <div class="small-loader input-load merged-card-loader" *ngIf="paymentLoad"></div></button>
                <button class="btn cancel-btn fnt-14 bg-fff f500  mar-left-10" (click)="_bsModalRef.hide()">Cancel</button>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>

    <ng-template #blinkerMsg>
      <div class="modal-bg coupon-error blinkit-msg">
        <span class="error-line"> Thank you for your interest in the offer. This offer is temporarily unavailable, we will reach out to you as soon as the offer is live. Thank you for your patience. </span>
      </div>
    </ng-template>
